export const COLLISION_STATES = ['viewing', 'replying', 'noting', 'typing']
export const REFETCH_COLLISIONS_INTERVAL = 300000 // 300 seconds, a.k.a. 5 minutes
// The leave timeout is 1 minute to ensure that other agents would'nt pickup tickets
// while an agent switches to a different tab to reference information related to the ticket
// Eg: Checking backend system for some data to respond to the customer
export const LEAVE_TIMEOUT = 60000

// export const COLLISION_ACTIONS = ['viewing', 'replying', 'noting', 'typing']
